// extracted by mini-css-extract-plugin
export default {"navLink":"Navigation_navLink__kEMnQ","active":"Navigation_active__mXCtJ","inactive":"Navigation_inactive__T6GCZ"};